import { useState } from "react"
import { getAccountTypes } from "../template/TemplateHelper"
import "./ClientAccountCreator.css"
import { formatSsnValue } from "./util/CrmFieldUtil"
import defaultNumberOfAccountHolders from "../template/constants/defaultNumberOfAccountHolders.json"

const ClientAccountCreator = ({ broker, selectedClient, handleCreateClientAccount }) => {
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [socialSecurityNumber, setSocialSecurityNumber] = useState("")
    const [accountList, setAccountList] = useState([{accountPlatform: "", accountType: "", numberOfAccountHolders: null}])
    const [errorMessage, setErrorMessage] = useState(null)

    const onSubmit = async (e) => {
        e.preventDefault()
        setErrorMessage("")
        let clientDetails = {
            firstName: firstName?.trim(),
            lastName: lastName?.trim(),
            socialSecurityNumber: socialSecurityNumber?.trim()
        }
        handleCreateClientAccount(clientDetails, accountList)
        resetForm()
    }

    const resetForm = () => {
        setFirstName("")
        setLastName("")
        setSocialSecurityNumber("")
        setAccountList([{accountPlatform: "", accountType: ""}])
    }

    const handleAccountChange = (e, index) => {
        let updatedAccountList = [...accountList]
        let updatedAccount  = {
            accountType: "",
            accountPlatform: e.target.value
        }

        updatedAccountList[index] = updatedAccount

        setAccountList(updatedAccountList)
    }

    const handleAccountTypeChange = (e, index) => {
        let updatedAccountList = [...accountList]
        let accountType = e.target.value
        updatedAccountList[index]["accountType"] = accountType

        if(broker === "SIGMA" || broker === "AXTELLA") {
            updatedAccountList[index]["numberOfAccountHolders"] = defaultNumberOfAccountHolders[accountType]
        }

        setAccountList(updatedAccountList)
    }

    const handleNumberOfAccountHoldersChange = (e, index) => {
        let updatedAccountList = [...accountList]
        updatedAccountList[index]["numberOfAccountHolders"] = e?.target?.value

        setAccountList(updatedAccountList)
    }

    const getAccountOptions = () => {
        let accountTypes = getAccountTypes(broker)
        return Object.keys(accountTypes).map(key => <option value={key}>{key}</option>)
    }

    const getAccountTypeOptions = (accountPlatform) => {
        let accountTypes = getAccountTypes(broker)
        return accountTypes[accountPlatform]?.map(key => <option value={key}>{key}</option>)
    }

    const addAccount = () => {
        let updatedAccountList = [...accountList]
        updatedAccountList.push({
            accountPlatform: "", 
            accountType: ""
        })

        setAccountList(updatedAccountList)
    }

    const deleteAccount = () => {
        let updatedAccountList = [...accountList]
        updatedAccountList.splice(-1)

        setAccountList(updatedAccountList)
    }

    const applyCurrentClientInfo = () => {
        if(selectedClient) {
            setFirstName(selectedClient.firstName)
            setLastName(selectedClient.lastName)
            setSocialSecurityNumber(selectedClient.socialSecurityNumber)
        }
    }

    return(
        <div className="create-client">
            <div className='top-header'>
                <header>Create Account</header>
            </div>
            {errorMessage && 
                <div className="errorMessage">
                    <p>{errorMessage}</p>
                </div>
            }
            <form onSubmit={(e) => onSubmit(e)}>
                <h3>Client</h3>
                <div className="form-group">
                    <label for="firstName">First Name</label>
                    <input className="inpt" id="firstName" name="firstName" required value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                </div>
                <div className="form-group">
                    <label for="lastName">Last Name</label>
                    <input className="inpt" id="lastName" name="lastName" required value={lastName} onChange={(e) => setLastName(e.target.value)} />
                </div>
                <div className="form-group">
                    <label for="socialSecurityNumber">Social Security Number</label>
                    <input className="inpt" id="socialSecurityNumber" name="socialSecurityNumber" value={socialSecurityNumber} onChange={(e) => setSocialSecurityNumber(formatSsnValue(e.target.value))} />
                </div>
                <div className="create-client-account-button">
                    <button type="button" onClick={() => applyCurrentClientInfo()}>Use current client</button>
                </div>

                {
                    accountList.map((account, index) => {
                        let accountPlatform = account["accountPlatform"]
                        let accountType = account["accountType"]
                        let numberOfAccountHolders = null

                        if(broker === "SIGMA" || broker === "AXTELLA") {
                            numberOfAccountHolders = account["numberOfAccountHolders"]
                        }

                        let isFirstAccount = index === 0
                        let isLastAccount = accountList.length === index + 1
                        return (
                            <>

                                <h3>Account {accountList.length > 1 && index + 1}</h3>
                                <div className="form-group">
                                    <label for="accountPlatform">Account Platform</label>
                                    <select className="inpt" id="accountPlatform" name="accountPlatform" value={accountPlatform} required onChange={(e) => handleAccountChange(e, index)} > 
                                        <option disabled selected value="">Account Platform</option>
                                        {getAccountOptions()}
                                    </select>
                                </div>
                                
                                {(getAccountTypes(broker)[accountPlatform] && getAccountTypes(broker)[accountPlatform].length > 0) &&
                                    <>
                                        <div className="form-group">
                                            <label for="accountType">Account Type</label>
                                            <select className="inpt" id="accountType" name="accountType" value={accountType} required onChange={(e) => handleAccountTypeChange(e, index)} > 
                                                <option disabled selected value="">Account Type</option>
                                                {getAccountTypeOptions(accountPlatform)}
                                            </select>
                                        </div>
                                        {
                                            (broker === "SIGMA" || broker === "AXTELLA") &&
                                            <div className="form-group">
                                                <label for="numberOfAccountHolders">Number of Account Holders</label>
                                                <input className="inpt" type="number" id="numberOfAccountHolders" name="numberOfAccountHolders" required value={numberOfAccountHolders} onChange={(e) => handleNumberOfAccountHoldersChange(e.target.value, index)} />
                                            </div>
                                        }
                                    </>
                                }
                                <div className="create-client-account-button">
                                    {(!isFirstAccount && isLastAccount)  && <button type="button" onClick={() => deleteAccount()}>Delete</button>}
                                    {isLastAccount && <button type="button" onClick={() => addAccount()}>Add</button>}
                                </div>
                            </>
                        )
                    })
                }
                <div className="form-group">
                    <button className="crm-button" type="submit">Create Account</button>
                </div>
            </form>
        </div>
    )
}

export default ClientAccountCreator